var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.endShow)?_c('v-btn',{attrs:{"tile":"","block":"","depressed":""},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("Назад")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }